// utils/subdomainUtils.js

// get sub-domain from URL
export const getSubdomain = (url) => {
    // Remove protocol if present (http:// or https://)
    let domain = url.includes("://") ? url.split('://')[1] : url;
  
    // Remove any path or query params after the domain
    domain = domain.split('/')[0];
  
    // Split the domain by '.'
    const parts = domain.split('.');
  
    // If the first part is 'www', return the second part; otherwise return the first part
    if (parts.length > 1) {
      return parts[0] === 'www' ? parts[1] : parts[0]; // Return first part as subdomain
    }
  
    return domain; // If only one part, return it (e.g., localhost)
  };
  